import { FEATURE_TOGGLES } from '../constants';
import { useStore } from '../zustand/stores';

export const useIsGenAnswer = () => {
  const featureTogglesSlice = useStore((state) => state.featureTogglesSlice);

  const isAiServicesDisabled =
    featureTogglesSlice[FEATURE_TOGGLES.DISABLE_AI_SERVICES];

  return !isAiServicesDisabled;
};
